<template>
  <v-dialog v-model="showDeleteAlertPopup" persistent max-width="720">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure you want to archive
        the <b>"Quantity is {{ alertType }} to {{ alertValue }}"</b>
        alert for the <b>"{{ itemName }}"</b>?
      </v-card-title>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="cancel"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="confirmDelete"
          depressed
          class="save-btn small-size"
          >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  MODULE_POPUP,
  SET_DELETE_ALERT_POPUP_SHOW
} from '@/store/constant/mutation-types'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ConfirmPopup',
  props: ['item'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('popup', ['alertPendingToSave']),
    showDeleteAlertPopup() {
      return this.$store.getters[`${MODULE_POPUP}/showDeleteAlertPopup`]
    },
    alertType() {
      const data = this.$store.getters[`${MODULE_POPUP}/alertPendingToSave`]
      return data === null ? '' : data.type
    },
    alertValue() {
      const data = this.$store.getters[`${MODULE_POPUP}/alertPendingToSave`]
      return data === null ? '' : data.value
    },
    itemName() {
      return this.item.name
    },
    alertId() {
      const data = this.$store.getters[`${MODULE_POPUP}/alertPendingToSave`]
      return data === null ? '' : data.id
    }
  },
  methods: {
    ...mapActions('alerts', ['deleteAlert']),
    hide() {
      this.$store.commit(
        `${MODULE_POPUP}/${SET_DELETE_ALERT_POPUP_SHOW}`,
        false
      )
    },
    confirmDelete() {
      const alertData = this.alertPendingToSave
      const payload = {
        alertId: alertData.id
      }
      this.deleteAlert(payload)
      this.hide()
    },
    cancel() {
      this.hide()
    }
  }
}
</script>

<style scoped></style>
